export default ({ request }) => ({
  appVersionRecordsListApi(data = {}, params) {
    return request({
      url: '/sys/app/versionRecords/list',
      method: 'POST',
      data,
      params
    })
  },
  appVersionRecordsDetailApi(data = {}) {
    return request({
      url: '/sys/app/versionRecords/detail',
      method: 'POST',
      data
    })
  },
  appVersionRecordsSaveApi(data = {}) {
    return request({
      url: '/sys/app/versionRecords/save',
      method: 'POST',
      data
    })
  },
  appVersionRecordsDelApi(data = {}) {
    return request({
      url: '/sys/app/versionRecords/del',
      method: 'POST',
      data
    })
  },
  appVersionRecordsReleaseApi(data = {}) {
    return request({
      url: '/sys/app/versionRecords/release',
      method: 'POST',
      data
    })
  },
  appVersionRecordsQrCodeApi(data = {}) {
    return request({
      url: '/sys/app/versionRecords/qrCode',
      method: 'POST',
      data
    })
  },
  appVersionRecordsRollbackApi(data = {}) {
    return request({
      url: '/sys/app/versionRecords/rollback',
      method: 'POST',
      data
    })
  }
})
